<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EndpointCases from './cases'

export default {
  page: {
    title: 'Endpoint cases',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, EndpointCases },
  data () {
    return {
      title: 'Endpoint cases',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Endpoints',
          href: '/endpoints/cases'
        },
        {
          text: 'Cases',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <EndpointCases />
  </Layout>
</template>
